import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import { BarChart as BarChartIcon, ArrowForward as ArrowForwardIcon, Group as GroupIcon, Search as SearchIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const CTASection = () => {
  const navigate = useNavigate();

  const features = [
    {
      icon: <BarChartIcon color="primary" />,
      title: 'Market Position Analysis',
      description: 'Deep dive into company positioning, target audience, and unique value propositions'
    },
    {
      icon: <SearchIcon color="primary" />,
      title: 'Competitor Discovery',
      description: 'Automatically find and analyze relevant competitors in your market space'
    },
    {
      icon: <GroupIcon color="primary" />,
      title: 'User Insights',
      description: 'Access user feedback analysis and persona creation tools'
    }
  ];

  return (
    <Box
      sx={{
        textAlign: 'center',
        my: 8,
        py: 8,
        px: 4,
        background: 'linear-gradient(135deg, rgba(0,118,255,0.05) 0%, rgba(103,58,183,0.05) 50%, rgba(103,58,183,0) 100%)',
        borderRadius: 4
      }}
    >
      <Stack spacing={3} alignItems="center">
        <Typography
          variant="h3"
          sx={{
            fontWeight: 700,
            background: 'linear-gradient(135deg, #0070f3 0%, #6743b5 60%, rgba(103,58,183,0.7) 100%)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            color: 'transparent'
          }}
        >
          Ready to dive deeper into analysis?
        </Typography>

        <Typography variant="h5" color="text.secondary" sx={{ maxWidth: 600 }}>
          Get access to advanced features and comprehensive market insights
        </Typography>

        <Grid container spacing={3} justifyContent="center" sx={{ maxWidth: 900 }}>
          {features.map((feature, index) => (
            <Grid item xs={12} sm={4} key={index}>
              <Box sx={{ p: 2 }}>
                {feature.icon}
                <Typography variant="h6" sx={{ mt: 1, mb: 1 }}>
                  {feature.title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {feature.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>

        <Button
          variant="contained"
          size="large"
          endIcon={<ArrowForwardIcon />}
          onClick={() => {
            if (typeof ym === 'function') {
              ym(96014345, 'reachGoal', 'beachhead_analysis_cta_click');
            }
            navigate('/lp-analysis');
          }}
          sx={{
            px: 6,
            py: 2,
            mt: 4,
            borderRadius: '9999px',
            background: 'linear-gradient(135deg, #3b82f6 0%, #9333ea 100%)',
            boxShadow: '0 4px 12px rgba(59, 130, 246, 0.25)',
            '&:hover': {
              background: 'linear-gradient(135deg, #2563eb 0%, #7e22ce 100%)',
              boxShadow: '0 6px 16px rgba(59, 130, 246, 0.35)'
            },
            transition: 'all 0.3s ease'
          }}
        >
          Get full analysis
        </Button>

        <Typography variant="body2" color="text.secondary">
          Join 12000+ marketers who saved 1000+ days on manual research
        </Typography>
      </Stack>
    </Box>
  );
};

export default CTASection;
